import { atom } from 'jotai'

export const stateAtom = atom({ sending: false, profileSheetFormInvalid: false })
